import { Injectable, Renderer2, RendererFactory2, Inject, AfterViewInit, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { timer } from 'rxjs';
import { Observable, BehaviorSubject } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable()
export class SpinnerService implements OnInit {

  private visible$ = new BehaviorSubject<boolean>(false);
  private renderer: Renderer2;
  public pendingRequests: number = 0;

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document){

    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  ngOnInit(): void {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  show() {
    // window.scroll(0, 0);
    this.pendingRequests++;
    // this.renderer.addClass(document.body,'modal-open');
    this.document.body.scrollTop = 0;
    this.visible$.next(true);
   
  }

  hide() {
    this.pendingRequests--;
    // this.renderer.removeClass(document.body, 'modal-open');
    
    if(this.pendingRequests<=0){
      this.visible$.next(false);
    }   
  }

  isVisible(): Observable<boolean> {
    return this.visible$.asObservable().pipe(share());
  }

  forClose(){
    this.pendingRequests = 0;
    this.visible$.next(false);
  }
}
